import { useForm, UseFormReturn } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { useMemo } from 'react';

export const useCustomForm = (
  validationSchema: Record<string, any>,
  defaultValues: Record<string, any>,
  valuesIsChange?: (values: any) => void
): {
  formMethods: UseFormReturn<any, any>;
  changeHandler: (key: string, value: any) => void;
  trigger?: any;
  register?: any;
  formState?: any;
  control?: any;
  setError?: any;
  getValues?: any;
  clearErrors?: any;
  reset?: any;
  handleSubmit?: any;
  watch?: any;
  setValue?: any;
} => {
  const formMethods = useForm({
    resolver: yupResolver(validationSchema as any),
    defaultValues,
    mode: 'onChange',
  });

  const {
    setValue,
    trigger,
    formState: { isValidating,validatingFields },
    getValues,
  } = formMethods;
  const values = getValues();

  const changeHandler = (key: string, value: any) => {
    setValue(key, value);
    trigger(key);
  };

  useMemo(() => {
    valuesIsChange && valuesIsChange(values);
  }, [isValidating,validatingFields]);
  return {
    ...formMethods,
    changeHandler,
  } as any;
};
